import { render } from "./NetworkError.vue?vue&type=template&id=3155be8b"
const script = {}
script.render = render

export default script